
/**
 * Represents a company model.
 */
export class CompanyModel {
    /**
     * The unique code of the company.
     */
    Company_Code: number =0;

    /**
     * The name of the company.
     */
    Company_Name: string ='';

    /**
     * The acronym of the company.
     */
    Company_Acronym: string ='';

    /**
     * Indicates whether the company is active.
     */
    Active: boolean = false;

    /**
     * The ID of the user who created the company record.
     */
    Created_By: number=0;

    CompStatus: string = '';
    
}